/**
 * Constants for Product Availability module
 * Centralized configuration values for better maintainability
 */

// Pagination
export const DEFAULT_PAGE_SIZE = 10;

// UI Breakpoints
export const MOBILE_BREAKPOINT = 768;

// Table Headers
export const TABLE_HEADERS = {
  PRODUCT_NUMBER: "Product Number",
  PRODUCT_NAME: "Product Name",
  CATEGORY: "Category",
  SUBCATEGORY: "Subcategory",
  PRICE: "Price",
  OFFER_PRICE: "Offer Price",
  STATUS: "Status",
};

// Status Values
export const STATUS = {
  AVAILABLE: "Available",
  NOT_AVAILABLE: "Not Available",
};

// Status Styles
export const STATUS_COLORS = {
  AVAILABLE: {
    background: "#4caf50",
    text: "white",
  },
  NOT_AVAILABLE: {
    background: "#f44336",
    text: "white",
  },
};

// Export File Names
export const EXPORT_FILE_NAME = "Product_Availability.pdf";

// Search Placeholder
export const SEARCH_PLACEHOLDER = "Search products...";

// Button Labels
export const BUTTON_LABELS = {
  EXPORT_PDF: "Export All to PDF",
};

// Messages
export const MESSAGES = {
  NO_PRODUCTS: "No products found.",
  ERROR_FETCHING: "Error fetching products",
};
